import { render, staticRenderFns } from "./addAccessUser.vue?vue&type=template&id=30fe6a66&scoped=true&"
import script from "./addAccessUser.vue?vue&type=script&lang=js&"
export * from "./addAccessUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fe6a66",
  null
  
)

export default component.exports